import styled from 'styled-components';

export const CardWrapper = styled.div`
  padding: 2rem 1.6rem;
  width: 100%;
  height: 15.6rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  border-radius: ${({ theme }) => theme.borderRadius.x4};
  border: 1px solid ${({ theme }) => theme.colors.borders.default};

  box-shadow: ${({ theme }) => theme.shadows.xl};
`;

type PriceIconWrapperProps = {
  isPriceLow?: boolean;
};

export const PriceIconWrapper = styled.div<PriceIconWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  width: 3.6rem;
  height: 3.6rem;
  background-color: ${({ theme, isPriceLow }) =>
    isPriceLow ? theme.colors.surface.rejectedBackground : '#EBF5E8'};
`;

export const CardDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;
`;
